import React, { useContext, useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { numberWithCommas } from 'helper';
import { ModalContext } from 'App';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';
import * as actions from '../action';
import * as c from '../constant';

const TABLE_VARIANTS = [
  { key: 'planning', value: 'PLANNING DEPARTMENT', label: 'Planning' },
  { key: 'engineering', value: 'ENGINEERING DEPARTMENT', label: 'Engineering' },
];

function FeesTable({ isLoading, getFeesList, deleteFee, feesList, type }) {
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');

  const handleAdd = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <CreateModal
          deptOptions={TABLE_VARIANTS}
          department={TABLE_VARIANTS.find((item) => item.key === type).value}
        />
      ),
      title: 'Add Fee',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          data={data}
          deptOptions={TABLE_VARIANTS}
          department={TABLE_VARIANTS.find((item) => item.key === type).value}
        />
      ),
      title: 'Update Fee',
      modalSize: 'modal-md',
    });
  };

  const handleDelete = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to delete this fee?`,
      () => {
        deleteFee(data.id, () => {
          getFeesList({
            department: TABLE_VARIANTS.find((item) => item.key === type).value,
          });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getFeesList({
      department: TABLE_VARIANTS.find((item) => item.key === type).value,
    });
  }, [type]);

  if (isLoading) {
    return (
      <div
        className="loading d-flex justify-content-center align-items-center"
        style={{ height: '150px' }}
      >
        <div className="spinner text-center">
          <span className="fas fa-3x fa-spin fa-spinner" />
        </div>
      </div>
    );
  }

  return (
    <div className="card p-0">
      <div className="card-content-listing">
        <div className="container-fluid p-0">
          <div className="row d-flex align-items-center">
            <div className="col-6 text-capitalize">
              <h3>{`${type} Fees`}</h3>
            </div>
            {Acl(permissions, [
              `EBPLS FEES SETTING ADD ${type.toUpperCase()}`,
            ]) && (
              <div className="col-6 ml-auto text-right">
                <button
                  className="btn btn-primary cms-bg-color-primary cms-outline-primary mb-2 font-weight-bold"
                  type="button"
                  onClick={handleAdd}
                >
                  Add Fee
                </button>
              </div>
            )}
          </div>
          {/* TABLE */}
          <div className="table-responsive mt-4">
            <table className="transaction-table table table-striped table-sm">
              <tbody>
                <tr>
                  <th
                    className="p-2 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                    width="40%"
                  >
                    Annual Inspection Fee
                  </th>
                  <th
                    className="p-2 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                    width="40%"
                  >
                    Amount
                  </th>
                  <th
                    className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                    width="20%"
                  />
                </tr>
                {!_.isEmpty(feesList) ? (
                  feesList?.map((item) => (
                    <Fragment key={item.id}>
                      <tr>
                        <td className="text-dark align-middle">
                          {_.get(item, 'attributes.name') || '-'}
                        </td>
                        <td className="text-dark align-middle">
                          <b>PHP</b> &nbsp;
                          {numberWithCommas(_.get(item, 'attributes.amount')) ||
                            '0'}
                        </td>
                        <td className="text-dark align-middle">
                          <div className="ml-auto">
                            {Acl(permissions, [
                              `EBPLS FEES SETTING EDIT ${type.toUpperCase()}`,
                            ]) && (
                              <button
                                type="button"
                                className="btn-blank"
                                onClick={handleEdit(item)}
                              >
                                <i className="far fa-edit icon-edit cms-bg-color-primary" />
                              </button>
                            )}
                            {Acl(permissions, [
                              `EBPLS FEES SETTING DELETE ${type.toUpperCase()}`,
                            ]) && (
                              <button
                                type="button"
                                className="btn-blank"
                                onClick={handleDelete(item)}
                              >
                                <i className="far fa-trash-alt icon-delete" />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    </Fragment>
                  ))
                ) : (
                  <tr className="text-dark text-center">
                    <td className="text-dark text-center" colSpan="3">
                      No Fees
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

FeesTable.propTypes = {
  getFeesList: PropTypes.instanceOf(Function).isRequired,
  deleteFee: PropTypes.instanceOf(Function).isRequired,
  feesList: PropTypes.instanceOf(Array).isRequired,
  type: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  feesList: _.get(api, `${c.GET_FEES_LIST}.list`) || [],
  isLoading: api.loading.indexOf(c.GET_FEES_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(FeesTable);
